import { CommitteeModelExtended } from "@api/models/committees/CommitteeModel";
import { rawConverter } from "@api/models/objects/Converters";
import { ObjectRepository } from "@api/repositories/ObjectRepository";
import { TicketRowInterfaceView } from "@share/committees/common/types/interfaces/TicketsRowInterface";
import { TicketSchema } from "@share/ticketSystem/enums/TicketSchemas";
import { TicketType } from "@share/ticketSystem/enums/TicketTypes";

export class CommitteeViewService {

    constructor(
        private readonly objectRepository: ObjectRepository,
    ) {
    }

    private readonly COMMITTEES_SCHEMA_ID = "Committees";

    /**
     * Returns committee by id
     * @param id
     * @returns
     */
    async getCommittee(id: string) {
        const query = {
            take: 1,
            where: {
                id: id
            },
            include: [
                'id', 'title', 'description', 'userIds', 'ticketIds',
                'beginAt', 'endAt', 'subjectType', 'location', 'isClosed',
                'link', { 'company': ['id', 'title',  { 'parentId': ['title', { 'parentId': ['title'] }] }] }, 'secretary',
            ]
        }

        return await this.objectRepository.query<CommitteeModelExtended[]>(this.COMMITTEES_SCHEMA_ID, query, rawConverter);
    }

    async getTickets(ids: string[], type: TicketType) {
        const query = {
            include: [
                'id',
                'title',
                'ownerIds',
                'createdAt',
                'implementedAt',
                'responsibleUserId',
                'responsibleForImplementationUserId',
                { 'company': ['title'] },
                { 'status': ['title', 'color', 'iconFileId', 'code'] },
                { 'category': ['title'] }
            ],
            where: {
                id: {
                    '$in': ids
                }
            },
            take: -1

        }

        const SCHEMA_ID = type === TicketType.idea ? TicketSchema.idea : TicketSchema.problem;

        return this.objectRepository.query(SCHEMA_ID, query, rawConverter) as any as TicketRowInterfaceView[];
    }

    async endTicket(id: string) {
        await this.objectRepository.update(this.COMMITTEES_SCHEMA_ID, id, { isClosed: true });
    }
}
